import {DATE} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
import {date, apiDate} from '@drivesally/sally-fw/lib/type';

export default attribute({
  type: DATE,
  attribute: 'policy_effective_date',
  display: date,
  input: date,
  api: apiDate,
  label: {
    default: 'Effective Date',
    short: 'Effective Date',
  },
});
